import { render, staticRenderFns } from "./whiteBookFile.vue?vue&type=template&id=5ddbf760&scoped=true"
import script from "./whiteBookFile.vue?vue&type=script&lang=js"
export * from "./whiteBookFile.vue?vue&type=script&lang=js"
import style0 from "./whiteBookFile.vue?vue&type=style&index=0&id=5ddbf760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddbf760",
  null
  
)

export default component.exports